// hooks/useHubspotAddress.ts
import { useQuery } from "@tanstack/react-query";
import { fetch } from "../lib/fetch";

type UiAddress = {
  streetAddress: string | null;
  postalCode: string | null;
  city: string | null;
  stateRegion: string | null;
  countryRegion: string | null;
};

export function useHubspotAddress(contactId?: string | number, opts?: { enabled?: boolean }) {
  return useQuery<UiAddress | null>({
    queryKey: ["hubspotAddress", contactId],
    enabled: !!contactId && (opts?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      if (!contactId) return null;
      return await fetch(`/api/hubspot/contacts/${contactId}/address`);
    },
  });
}


